import styled from 'styled-components'

export const Overlay = styled.div<{isLoading: boolean}>`
  ${({ isLoading }) => isLoading && `
    opacity: 0.6;
    pointer-events: none;
  `}
`